export const FORM_DATA_KEYS_MAP = {
  policyDate: 'policy_date',
  travelType: 'travelType',
  numadults: 'numadults'
}

export const APPLE_PAY_PAYMENT_OPTIONS = ['APPLEPAY', 'AP']
export const AmexCC = 'AmexCC'
export const AVAILABLE_PAYMENT_OPTIONS = ['CC', 'DC', ...APPLE_PAY_PAYMENT_OPTIONS, AmexCC]

export const retryCount = 3